export const RENEWAL_ACTIVE_STATES = ['AR', 'CE'];
export const RENEWAL_INACTIVE_STATES = ['CD']
export const RENEWAL_ALLOWED_UPDATE_TO = ['CD','CE', null] as const;
